import { openBackInStockEmailModal } from './openBackInStockEmailModal';
import { fetchBackInStockSettings } from './fetchBackInStockSettings';
export function createBackInStockExports(_a) {
    var context = _a.context, origin = _a.origin, isOnlineStoresViewerScript = _a.isOnlineStoresViewerScript;
    return {
        openBackInStockEmailModal: openBackInStockEmailModal({ context: context, origin: origin, isOnlineStoresViewerScript: isOnlineStoresViewerScript }),
        fetchBackInStockSettings: fetchBackInStockSettings({ context: context, origin: origin, isOnlineStoresViewerScript: isOnlineStoresViewerScript }),
    };
}
//# sourceMappingURL=exports.backInStock.js.map